import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {NavLink} from 'react-router-dom';

import * as selector from '../../selectors';

const mapStateToProps = state => {
	return {
		settings: selector.getSettings(state),
	};
};

@connect(mapStateToProps)
export default class extends Component {
	static propTypes = {
		settings: PropTypes.object,
	}

	render() {
		const {
			settings: {
				plan,
			},
		} = this.props;

		return (
			<ul className="nav nav-fill nav-justified">
				<li className="nav-item">
					<NavLink to="/book" className="nav-link custom-border-active">
						Бронирование<span className="d-none d-sm-none d-md-inline"> стола</span>
					</NavLink>
				</li>
				{plan &&
				<li className="nav-item">
					<NavLink to="/plan" className="nav-link custom-border-active">
						План<span className="d-none d-sm-none d-md-inline"> заведения</span>
					</NavLink>
				</li>}
			</ul>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/common/Navbar.js